<div class="wrapper">
  <button
    mat-button
    color="primary"
    class="product-name"
    [class.product-name-vertical]="!isVisible()"
    (click)="toggleVisibility()"
  >
    <span>
      Расходы по продукту
    </span>
    @if (isVisible()) {
      <span class="product-plan">
        План мес. {{ formatBudgetValue(productExpensesParams().plannedMonthPrice) }} / день {{ formatBudgetValue(productExpensesParams().plannedDayPrice) }}
      </span>
    }
  </button>
  @if (isVisible()) {
    <div
      class="team-expenses-content"
      @smoothShowHideWidth
    >
      <div class="team-expenses-month">
        {{ releaseCalendarSelectedOptions().monthName }}
      </div>
      <div class="calendar">
        <div class="calendar-header">
          @for (day of days; track $index) {
            <div class="day">
              {{ day }}
            </div>
          }
        </div>
        <div class="calendar-body">
          @for (day of totalDays(); track $index) {
            <div
              class="day"
              [class.day-empty]="day === 0"
            >
              @if (day !== 0) {
                <div class="day-number">
                  <div>
                    {{ day }}
                  </div>
                  @if (loginAndRoles().role === 'ROLE_ADMIN') {
                    <button
                      mat-fab
                      class="day-edit-btn"
                      [class.visible]="getVisibleEditButton(day)"
                      [matTooltip]="getTooltip(day)"
                      (click)="handleEditPlanFact(day)"
                    >
                      <mat-icon>edit</mat-icon>
                    </button>
                  }
                </div>
                @if (hasDataForDay(day)) {
                  @let dayData = dayExpensesMap().get(day);
                  <div
                    class="day-price"
                    [class.limit-exceeding]="dayData?.isLimitExceeded"
                  >
                    @for (expense of productExpenses(); track $index) {
                      <div>
                        @if (isSameDay(expense, day)) {
                          <div>
                            {{ formatBudgetValue(expense.price) }} / {{ expense.count }}
                          </div>
                        }
                      </div>
                    }
                  </div>
                } @else {
                  <div class="day-price">
                    {{ formatBudgetValue(0) }}
                  </div>
                }
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
